import { PathLike } from 'fs'
import { FileHandle } from 'fs/promises'

export const midBoxPositions = [11, 7, 3, 2]
export const taboolaPositionsGridVOD = (i: number) =>
  i === 1 || (i > 1 && (i - 1) % 5 === 0)

export interface ILiveSources {
  mobile: {
    provider: 'gmana' | 'kaltura'
    live_with_subs: string
    live_no_subs: string
  }
  desktop: {
    provider: 'gmana' | 'kaltura'
    live_with_subs: string
    live_no_subs: string
  }
}

export interface IConfigFile {
  ros_interstitial: 'on' | 'off' | string
  recently_aired_json_path: PathLike | FileHandle | null | string
  short_videos_client?: null | string
  short_videos_server?: null | string
  video_rail_map_path: PathLike | FileHandle | null | string
  live_title?: string
  live_h_title?: string
  live_description?: string
  siteName?: string
  logo?: string
  bb_ads_time_interval?: number
  player: {
    autoplay: {
      mobile: boolean
      desktop: boolean
      app: boolean
    }
  }
}

export interface IOttPageMeta {
  type: number
  externalId: string
  assetId: number
  seasonNumber: number
  title: string
  description: string
  ogImage: string
  ref: string
  seo: {
    title: string
    description: string
  }
}

export const liveSourcesDefault: ILiveSources = {
  mobile: {
    provider: 'gmana',
    live_with_subs:
      'https://reshet.g-mana.live/media/6f10d1da-0803-48d9-9272-57a811958974/mainManifest.m3u8',
    live_no_subs:
      'https://reshet.g-mana.live/media/cdefce3a-14ec-46cc-a147-1275c4a8b9ed/mainManifest.m3u8',
  },
  desktop: {
    provider: 'gmana',
    live_with_subs:
      'https://reshet.g-mana.live/media/4607e158-e4d4-4e18-9160-3dc3ea9bc677/mainManifest.m3u8',
    live_no_subs:
      'https://reshet.g-mana.live/media/87f59c77-03f6-4bad-a648-897e095e7360/mainManifest.m3u8',
  },
}
